import { useQueryClient, useMutation } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import { ErrorMonitoringService } from "@/shared/services";

import { UpdateLayoutRequest } from "../LayoutRecord";

import * as GetLayouts from "./useLayouts";

export function useUpdateLayout() {
  const { layoutService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: {
      layoutId: string;
      updates: UpdateLayoutRequest;
    }) => {
      if (currentOrganization === null) {
        return Promise.reject(new Error("CurrentOrganization is not set"));
      }

      return layoutService.updateLayout(
        request.layoutId,
        request.updates,
        currentOrganization.org_id,
      );
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: GetLayouts.getQueryKey(),
      });
    },
    onError: (error) => {
      ErrorMonitoringService.captureError(error);
    },
  });
}
